import authAxioInstance from "./authAxioInstance";

export const esignToolApi = {
    // get pdfeditor details

    signupSendOtp: async (email) => {
      const response = await authAxioInstance.post(
          `/EsignServices/SendOtp`,
          { email }
      );
      return response.data;
    },

    signupVerifyOtp: async (email, otp) => {
      const response = await authAxioInstance.post(
          `/EsignServices/verify_otp`,
          { email, otp }
      );
      return response.data;
    },

    sendFeedback: async (body) => {
      const response = await authAxioInstance.post(
          `/EsignServices/send_feedback`,
          body
      );
      return response.data;
    },

    login: async (username) => {
        const response = await authAxioInstance.post(
            `/EsignServices/get_pdf_editor_details`,
            { username }
        );
        return response.data;
    },

    sendOtpForgotPassword: async (email) => {
        const response = await authAxioInstance.post(
            `/EsignServices/NewSendOtpForgetPassword`,
            { email }
        );
        return response.data;
    },

    updatePassword: async (body) => {
        const response = await authAxioInstance.post(
            `/EsignServices/ChangePassword`,
            body
        );
        return response.data;
    },

    verifyOtp: async (email, otp) => {
        const response = await authAxioInstance.post(
            `/EsignServices/NewVerifyOtpForgetPassword`,
            { email, otp }
        );
        return response.data;
    },

    setNewPassword: async (email, new_password, otp) => {
        const response = await authAxioInstance.post(
            `/EsignServices/NewSetPasswordForgetPassword`,
            { email, new_password, otp }
        );
        return response.data;
    },

    // save signer details
    saveManualSigner: async (signerData, templateId, token) => {
      const response = await authAxioInstance.post(
        `/EsignServices/SaveEditDeleteSigner`,
        { ...signerData,
          document_id: templateId,
         },
        { 
        }
      );
      return response.data;
    },

    updateManualSigner: async (signerData, templateId, token) => {
      const response = await authAxioInstance.put(
        `/EsignServices/SaveEditDeleteSigner`,
        { ...signerData,
          document_id: templateId,
         },
        { 
        }
      );
      return response.data;
    },

    
    deleteManualSigner: async (signerID) => {
      const response = await authAxioInstance.delete(
        `/EsignServices/SaveEditDeleteSigner`,
        {
          data: { id: signerID },
        },
      );
      return response;
    },


    updateFrequentSigner: async (signerData) => {
      const response = await authAxioInstance.put(
        `/EsignServices/AddEditDeleteFrequentSigner`,
        { ...signerData,
         },
        { 
        }
      );
      return response.data;
    },

    addFrequentSigner: async (signerData) => {
      const response = await authAxioInstance.post(
        `/EsignServices/AddEditDeleteFrequentSigner`,
        { ...signerData,
         },
        { 
        }
      );
      return response.data;
    },

    // fetch saved signer details
    fetchManualSigner: async (templateId) => {
      const response = await authAxioInstance.get(
        `/EsignServices/SaveEditDeleteSigner?document_id=${templateId}`,
        { 
        }
      );
      return response.data;
    },

    // fetch user profile details 
    getUserProfileData: async () => {
      const response = await authAxioInstance.get(
        `/EsignServices/get-user-profile`,
      );
      return response.data;
    },

    // update user profile details 
    updateUserProfileData: async (body) => {
      const response = await authAxioInstance.put(
        `/EsignServices/update-user-profile`,
        body
      );
      return response.data;
    },

    // update user profile picture 
    updateUserProfilePicture: async (body) => {
      const response = await authAxioInstance.post(
        `/EsignServices/update-user-profile-picture`,
        body
      );
      return response.data;
    },

    deleteFrequentSigner: async (signerID) => {
      const response = await authAxioInstance.delete(
        `/EsignServices/AddEditDeleteFrequentSigner`,
        {
          data: { id: signerID },
        },
      );
      return response;
    },

    fetchfrequentSigner: async (searchText, page) => {
      const response = await authAxioInstance.get(
        `/EsignServices/FetchFrequentSigner?searched_text=${searchText}&page=${page + 1}`,
        { 
        }
      );
      return response.data;
    },

    addSignerfromFrequent: async (frequentsignerID, documentID) => {
      const response = await authAxioInstance.post(
        `/EsignServices/AddFrequentInSaveSigner`,
        { 
          ...frequentsignerID,
          document_id: documentID,
        },

      );
      return response.data;
    },

    scheduleInvite: async (data) => {
      const response = await authAxioInstance.post(
        `/EsignServices/SetScheduleTimeAndReminder`,
        data,
        {
        },

      );
      return response.data;
    },
    
    requestForEsign: async (data) => {
      const response = await authAxioInstance.post(
        `/EsignServices/NewRequestMultiSign`,
        data,
        {
        }

      );
      return response.data;
    },

    getAllSignerStatus: async (document_id, request_id) => {
      const response = await authAxioInstance.get(
        `/EsignServices/FetchSignerStatus?document_id=${document_id}&request_id=${request_id}`,
        {
        }

      );
      return response.data;
    },

    getAllSentToEsignDocument: async (pageno) => {
      const response = await authAxioInstance.post(
        `/EsignServices/NewGetEsignLog?page_num=${pageno}`,
        {
        }

      );
      return response.data;
    },

    searchDocument: async (data) => {
      const response = await authAxioInstance.post(
        `/EsignServices/NewGetEsignLogsearch`,
        data,
      );
      return response.data;
    },

    getAllEsignedDocument: async (pageno) => {
      const response = await authAxioInstance.post(
        `/EsignServices/NewGetEsignLogReceived?page=${pageno}`,
        {
        }

      );
      return response.data;
    },

    getAllEsignedSearchDocument: async (searchtext) => {
      const response = await authAxioInstance.post(
        `/EsignServices/NewGetEsignLogReceived?search_key=${searchtext}&fields=document_name,created_at`,
        {
        }

      );
      return response.data;
    },

    getTemplates: async () => {
      const response = await authAxioInstance.get(
        `/EsignServices/GetStaticTemplateFromS3`,
        {
        }

      );
      return response.data;
    },

    cloneSignerWithRequestId: async (request_id, document_id) => {
      const response = await authAxioInstance.post(
        `/EsignServices/CloneSignerWithRequestId`,
        {
          request_id,
          document_id,
        },
        {
          headers: {
            Authorization: `Bearer db1f5b8aa30d11efaa93c58cf55b45c8db1f5b8a`,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    },

    checkPendingEsign: async (document_id) => {
      const response = await authAxioInstance.post(
        `/EsignServices/CheckPendingEsign`,
        {
          document_id,
        },
      );
      return response.data;
    },

    expireLink: async (uuid_no) => {
      const response = await authAxioInstance.post(
        `/EsignServices/link-expire`,
        {
          uuid_no
        },
      );
      return response.data;
    },

    getEsignEmailTemplate: async () => {
      const response = await authAxioInstance.get(
        `/EsignServices/GetAndUpdateEmailTemplatePremium`,
        {
        }

      );
      return response.data;
    },

    getSuperadminCreditsData: async (body) => {
      const response = await authAxioInstance.post(
        `/EsignServices/visitors`,
        body
      );
      return response.data;
    },
  };
  